// extracted by mini-css-extract-plugin
export default {"trainingTemplate":"styles_trainingTemplate__N-dXt","fileUpload":"styles_fileUpload__sfUAK","attachmentContainer":"styles_attachmentContainer__D2hNZ"};